<template>
  <div class='EnbCheckoutItem01'>
    <div class="cont p">
      <enb-checkoutProd01 @DelLike="NewValue => $emit('DelLike', NewValue)" :data="data"/>
    </div>
    <div class="cont value">R$ {{ preco }}</div>
    <div class="cont value">
    </div>
    <div class="cont value">
      <button @click="push" v-if="Empresa.modelo !== 'Modelo 03'">Comprar</button>
      <btn-whats @click="sendMessageWhats(data)" v-if="Empresa.modelo === 'Modelo 03'"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EnbCheckoutProd01 from './EnbCheckoutProd01'
import BtnWhats from '@/components/Theme03/Produtos/Produto/BtnWhats'
export default {
  name: 'EnbCheckoutItem01',
  components: { EnbCheckoutProd01, BtnWhats },
  props: ['data'],
  computed: {
    ...mapGetters(['Empresa']),
    preco () {
      return this.data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    }
  },
  methods: {
    ...mapActions(['ToggleCheckout01', 'PushCheckout01', 'sendMessageWhats']),
    push () {
      this.PushCheckout01({ item: this.data, qtda: 1 })
      this.ToggleCheckout01(true)
    }
  }
}
</script>

<style scoped>
.EnbCheckoutItem01 {
  display: flex;
  border-top: thin solid #CCCCCC;
}

.cont {
  width: 20%;
  padding-top: 2%;
  padding-bottom: 2%;
}

.p {
  width: 40%;
}

.value {
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  border: 0;
  color: #FFFFFF;
  background-color: #4E7826;
  padding: 4%;
  border-radius: 5px;
  cursor: pointer;
}

@media (max-width: 500px) {
}
</style>
